<template>
  <div>
    <popup-add-campaign ref="popupAddCampaign" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">{{ title }}</h3>
        <p class="mt-5">{{ description }}</p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            @click="onClickCreateNew"
            type="relief"
            vslor="primary"
            v-if="hasPermissionForActiveVenue('vp.vp.venuecampaigns.create')"
            >Create campaign</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <Loading v-if="isLoading" />

    <!-- table -->
    <div
      v-if="!isLoading && source"
      id="data-list-list-view"
      class="data-list-container"
    >
      <vs-row vs-justify="flex-end" class="pr-6 mt-2">
        <vs-checkbox v-if="source == 'draftCampaigns'" v-model="showArchived"
          >Show archived</vs-checkbox
        >
        <vs-checkbox
          v-if="source == 'completedCampaigns'"
          v-model="showCancelled"
          >Show cancelled</vs-checkbox
        >
      </vs-row>

      <!-- Search Input -->
      <div class="mb-4 flex justify-end mt-3">
          <vs-input
            v-model="searchTerm"
            icon="search"
            @keyup.enter="onSearchEnter"
          />
      </div>

      <vs-table
        ref="table"
        class="mt-4"
        v-model="selected"
        :data="venueCampaigns"
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Title</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Type</vs-th>
          <vs-th>Email send date</vs-th>
          <vs-th>Sms send date</vs-th>
          <vs-th>NP Push send date</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="ShoutIcon" />
                  <p class="ml-4">
                    {{ tr.title }}
                  </p>
                </div>
              </vs-td>
              <vs-td>
                <vs-chip
                  :color="statusObject(tr.status).color"
                  class="product-order-status"
                >
                  {{ statusObject(tr.status).text }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <vs-chip class="product-order-status">
                  {{ typeToText(tr.isBasedOnMasterCampaign) }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <div v-if="tr.hasEmail" class="flex">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.sendEmailDate | formatDate }}
                </div>
                <span v-else></span>
              </vs-td>
              <vs-td>
                <div v-if="tr.hasSms" class="flex">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.sendSmsDate | formatDate }}
                </div>
                <span v-else></span>
              </vs-td>
              <vs-td>
                <div v-if="tr.hasNpPush" class="flex">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.sendNpPushDate | formatDate }}
                </div>
                <span v-else></span>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <!-- Manual Pagination -->
      <div class="flex justify-center mt-4">
        <vs-pagination
          :total="totalPages"
          v-model="currentPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import campaignMixin from "@/views/mixins/campaignMixin";
import PopupAddCampaign from "./Components/PopupAddCampaign.vue";
import ShoutIcon from "@/assets/images/shout-icon.png";

export default {
  components: {
    PopupAddCampaign,
  },
  mixins: [campaignMixin],
  props: ["title", "description", "source", "showCreateNewButton"],
  data() {
    return {
      newMessageTitle: "",
      selected: [],
      isLoading: true,
      ShoutIcon,

      showArchived: false,
      showCancelled: false,
      
      currentPage: 1,
      pageSize: 10,
      searchTerm: "",
      searchTimeout: null,
    };
  },
  methods: {
    getStatusesForSource() {
      switch (this.source) {
        case 'draftCampaigns':
          if (this.showArchived) {
            return ['ReadyToFillOut', 'Archived'];
          } else {
            return ['ReadyToFillOut'];
          }
        case 'pendingCampaigns':
          return ['SubmittedForApproval', 'Rejected'];
        case 'plannedCampaigns':
          return ['Approved', 'PartiallySent'];
        case 'completedCampaigns':
          if (this.showCancelled) {
            return ['Sent', 'ErrorSending', 'Cancelled'];
          } else {
            return ['Sent', 'ErrorSending'];
          }
        default:
          return [];
      }
    },

    async loadVenueCampaigns() {
      this.isLoading = true;
      const statuses = this.getStatusesForSource();
      await this.$store.dispatch("venueCampaigns/getForVenuePaginated", {
        venueId: this.activeVenue.venueId,
        statuses: statuses,
        searchTerm: this.searchTerm || null,
        page: this.currentPage,
        pageSize: this.pageSize
      });
      this.isLoading = false;
    },

    onClicked(id) {
      this.$router
        .push({
          name: "vp-venuecampaign",
          params: {
            id,
          },
        })
        .catch((e) => {});
    },
    typeToText(type) {
      if (type == null) return "Created By HQ";
      return type ? "Created by HQ" : "Created by Venue";
    },
    async onClickCreateNew() {
      this.$refs.popupAddCampaign.show(this.activeVenue.venueId);
    },
    onSearchEnter() {
      // Clear existing timeout and search immediately
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.currentPage = 1;
      this.loadVenueCampaigns();
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      venuePagination: "venueCampaigns/venuePagination",
    }),
    venueCampaigns() {
      // Return the paginated data directly from store - no modifications to prevent infinite loops
      return this.$store.getters["venueCampaigns/all"] || [];
    },
    totalItems() {
      return this.venuePagination && this.venuePagination.totalItems || 0;
    },
    totalPages() {
      return this.venuePagination && this.venuePagination.totalPages || 1;
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },

  watch: {
    currentPage() {
      console.log("Current page changed to", this.currentPage);
      this.loadVenueCampaigns();
    },
    showArchived() {
      this.currentPage = 1; // Reset to first page when filter changes
      this.loadVenueCampaigns();
    },
    showCancelled() {
      this.currentPage = 1; // Reset to first page when filter changes
      this.loadVenueCampaigns();
    },
    searchTerm() {
      // Debounce search to avoid too many API calls while typing
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1; // Reset to first page when search term changes
        this.loadVenueCampaigns();
      }, 1500); // Changed to 1.5 seconds
    },
  },

  async created() {
    this.isLoading = true;
    await this.loadVenueCampaigns();
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
